import { render, staticRenderFns } from "./kpi-activity-register.vue?vue&type=template&id=51e8bd5e&scoped=true"
import script from "./kpi-activity-register.vue?vue&type=script&lang=js"
export * from "./kpi-activity-register.vue?vue&type=script&lang=js"
import style0 from "./kpi-activity-register.vue?vue&type=style&index=0&id=51e8bd5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e8bd5e",
  null
  
)

export default component.exports